export default __webpack_public_path__ + "static/media/1928.ca97dd6b.png";